export default {
  "hierarchy": {
    "title": [
      "text-title"
    ],
    "subtitle": [
      "text-subtitle"
    ],
    "body": [
      "text-body"
    ],
    "bodySmall": [
      "text-bodySmall"
    ],
    "caption": [
      "text-caption"
    ],
    "captionSmall": [
      "text-captionSmall"
    ],
    "navLogoLabel": [
      "text-subtitle",
      "text-navLogoLabel"
    ],
    "pageTitle": [
      "text-title",
      "text-pageTitle"
    ],
    "sectionTitle": [
      "text-title",
      "text-sectionTitle"
    ],
    "sectionBody": [
      "text-bodySmall",
      "text-sectionBody"
    ],
    "cardTitle": [
      "text-subtitle",
      "text-cardTitle"
    ],
    "formTitle": [
      "text-title",
      "text-formTitle"
    ],
    "formSubtitle": [
      "text-subtitle",
      "text-formSubtitle"
    ],
    "formBody": [
      "text-body",
      "text-formBody"
    ],
    "listItemTitle": [
      "text-subtitle",
      "text-listItemTitle"
    ],
    "listItemSubtitle": [
      "text-caption",
      "text-listItemSubtitle"
    ],
    "inputCaptionSmall": [
      "text-captionSmall",
      "text-inputCaptionSmall"
    ],
    "inputCaptionSmallError": [
      "text-captionSmall",
      "text-inputCaptionSmall",
      "text-inputCaptionSmallError"
    ],
    "loginWarning": [
      "text-bodySmall",
      "text-loginWarning"
    ],
    "mobileMapTitle": [
      "text-bodySmall",
      "text-mobileMapTitle"
    ],
    "mobileTitle": [
      "text-bodySmall",
      "text-mobileTitle"
    ],
    "captionBold": [
      "text-captionBold"
    ],
    "captionSmallBold": [
      "text-captionSmallBold"
    ],
    "toastTitle": [
      "text-subtitle",
      "text-toastTitle"
    ],
    "toastMsg": [
      "text-caption",
      "text-toastMsg"
    ],
    "detailTitle": [
      "text-subtitle",
      "text-detailTitle"
    ],
    "detailLabel": [
      "text-bodySmall",
      "text-detailLabel"
    ],
    "detailValue": [
      "text-bodySmall",
      "text-detailValue"
    ],
    "detailSuffix": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailSuffix"
    ],
    "screenTitle": [
      "text-title",
      "text-screenTitle"
    ],
    "dialogTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle"
    ],
    "sideNav": [
      "text-sideNav"
    ],
    "loginLogo": [
      "text-loginLogo"
    ],
    "listDetailTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-listDetailTitle"
    ],
    "mobileUserNavBar": [
      "text-mobileUserNavBar"
    ],
    "groupTitle": [
      "text-captionSmall",
      "text-groupTitle"
    ],
    "dashboardCardTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-dashboardCardTitle"
    ],
    "dashboardCardEditorTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-dashboardCardTitle",
      "text-dashboardCardEditorTitle"
    ],
    "rootEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle"
    ],
    "actionBar": [
      "text-actionBar"
    ],
    "sideNavBarHeader": [
      "text-captionBold",
      "text-sideNavBarHeader"
    ],
    "networkOffline": [
      "text-networkOffline"
    ],
    "sideNavSmall": [
      "text-sideNav",
      "text-sideNavSmall"
    ],
    "linearViewHeaderCell1": [
      "text-linearViewHeaderCell1"
    ],
    "linearViewHeaderCell2": [
      "text-linearViewHeaderCell2"
    ],
    "pairingErrorSubtitle": [
      "text-pairingErrorSubtitle"
    ],
    "bodyCentered": [
      "text-body",
      "text-bodyCentered"
    ],
    "resendSuccess": [
      "text-resendSuccess"
    ],
    "twoFactorWarning": [
      "text-twoFactorWarning"
    ],
    "pill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill"
    ],
    "pillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary"
    ],
    "pillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess"
    ],
    "pillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning"
    ],
    "pillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError"
    ],
    "resendCodeSuccess": [
      "text-resendCodeSuccess"
    ],
    "twoStepTitle": [
      "text-twoStepTitle"
    ],
    "hint": [
      "text-hint"
    ],
    "columnValue": [
      "text-columnLabel",
      "text-columnValue"
    ],
    "columnLabel": [
      "text-columnLabel"
    ],
    "conditionTitle": [
      "text-bodySmall",
      "text-conditionTitle"
    ],
    "missingRelTitle": [
      "text-missingRelTitle"
    ],
    "expressionParen": [
      "text-expressionParen"
    ],
    "operatingHoursTitle": [
      "text-operatingHoursTitle"
    ],
    "hintSmall": [
      "text-hint",
      "text-hintSmall"
    ],
    "aggregationTitle": [
      "text-bodySmall",
      "text-detailLabel",
      "text-aggregationTitle"
    ],
    "aggregationLabel": [
      "text-aggregationLabel"
    ],
    "aggregationValue": [
      "text-subtitle",
      "text-aggregationValue"
    ],
    "overrideExample": [
      "text-overrideExample"
    ],
    "editorTitle": [
      "text-subtitle",
      "text-editorTitle"
    ],
    "conditionAttributeLabel": [
      "text-conditionAttributeLabel"
    ],
    "info": [
      "text-info"
    ],
    "conditionPropertyComparatorValue": [
      "text-conditionPropertyComparatorValue"
    ],
    "comparator": [
      "text-comparator"
    ],
    "tagError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tagError"
    ],
    "captionCurrent": [
      "text-caption",
      "text-captionCurrent"
    ],
    "tableConditionAttributeLabel": [
      "text-tableConditionAttributeLabel"
    ],
    "mobileNavSubtitle": [
      "text-mobileNavSubtitle"
    ],
    "navSecondaryMobileTitle": [
      "text-navSecondaryMobileTitle"
    ],
    "navSecondaryMobileHeader": [
      "text-navSecondaryMobileHeader"
    ],
    "mobileScreenTitle": [
      "text-mobileScreenTitle"
    ],
    "mobileOptNavTitle": [
      "text-mobileOptNavTitle"
    ],
    "mobileNavBarHeader": [
      "text-mobileNavBarHeader"
    ],
    "ruleTrigger": [
      "text-ruleTrigger"
    ],
    "ruleBlockTitle": [
      "text-ruleBlockTitle"
    ],
    "ruleBlockDescription": [
      "text-ruleBlockDescription"
    ],
    "captionLeft": [
      "text-caption",
      "text-captionLeft"
    ],
    "linkTable": [
      "text-linkTable"
    ],
    "pillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus"
    ],
    "pillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood"
    ],
    "pillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert"
    ],
    "value": [
      "text-value"
    ],
    "valueGood": [
      "text-value",
      "text-valueGood"
    ],
    "valueAlert": [
      "text-value",
      "text-valueAlert"
    ],
    "valueOffline": [
      "text-value",
      "text-valueOffline"
    ],
    "valueLowBattery": [
      "text-value",
      "text-valueLowBattery"
    ],
    "dashboardGridCardTitle": [
      "text-subtitle",
      "text-dashboardGridCardTitle"
    ],
    "passwordRequirement": [
      "text-caption",
      "text-passwordRequirement"
    ],
    "passwordRequirementSuccess": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementSuccess"
    ],
    "passwordRequirementError": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementError"
    ],
    "releaseAvailable": [
      "text-releaseAvailable"
    ],
    "openingHoursHeader": [
      "text-openingHoursHeader"
    ],
    "operatingHoursDay": [
      "text-operatingHoursDay"
    ],
    "groupingsCount": [
      "text-groupingsCount"
    ],
    "groupingsCountEmpty": [
      "text-groupingsCount",
      "text-groupingsCountEmpty"
    ],
    "formTitleCenter": [
      "text-title",
      "text-formTitle",
      "text-formTitleCenter"
    ],
    "valueGoodBattery": [
      "text-value",
      "text-valueLowBattery",
      "text-valueGoodBattery"
    ],
    "arrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue"
    ],
    "ruleTargetName": [
      "text-ruleTargetName"
    ],
    "rulePathSeparator": [
      "text-rulePathSeparator"
    ],
    "attributeTableUnitSuffix": [
      "text-attributeTableUnitSuffix"
    ],
    "selectorColumnValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-selectorColumnValue"
    ],
    "tablePill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-tablePill"
    ],
    "tablePillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-tablePillWarning"
    ],
    "tablePillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-tablePillSuccess"
    ],
    "tableArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-tableArrayValue"
    ],
    "tablePillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary",
      "text-tablePillPrimary"
    ],
    "tablePillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tablePillError"
    ],
    "tablePillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus",
      "text-tablePillStatus"
    ],
    "tablePillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-tablePillGood"
    ],
    "tablePillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert",
      "text-tablePillAlert"
    ],
    "deviceSelectorResults": [
      "text-deviceSelectorResults"
    ],
    "tempUserEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle",
      "text-tempUserEditorTitle"
    ],
    "tempUserShareError": [
      "text-tempUserShareError"
    ],
    "aggregationEnumAggLabel": [
      "text-aggregationLabel",
      "text-aggregationEnumAggLabel"
    ],
    "inputCaption": [
      "text-caption",
      "text-inputCaption"
    ],
    "attributeDetailUnitSuffix": [
      "text-attributeDetailUnitSuffix"
    ],
    "attributePercentEditor": [
      "text-attributePercentEditor"
    ],
    "detailArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-detailArrayValue"
    ],
    "detailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad"
    ],
    "tvCollectionItemTitle": [
      "text-title",
      "text-tvCollectionItemTitle"
    ],
    "tvDetailLabelNoPad": [
      "text-bodySmall",
      "text-detailLabel",
      "text-tvDetailLabelNoPad"
    ],
    "tvDetailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad",
      "text-tvDetailValueNoPad"
    ],
    "deviceCode": [
      "text-title",
      "text-deviceCode"
    ],
    "iconSuccessLarge": [
      "text-iconSuccessLarge"
    ],
    "titleLarge": [
      "text-title",
      "text-titleLarge"
    ],
    "bodyLarge": [
      "text-body",
      "text-bodyLarge"
    ],
    "altLoginMethod": [
      "text-captionSmall",
      "text-altLoginMethod"
    ],
    "altLoginMethodSmall": [
      "text-captionSmall",
      "text-altLoginMethod",
      "text-altLoginMethodSmall"
    ],
    "bodySmallBold": [
      "text-bodySmallBold"
    ],
    "qrCodeInstruction": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter",
      "text-qrCodeInstruction"
    ],
    "bodySmallBoldCenter": [
      "text-bodySmallBold",
      "text-bodySmallBoldCenter"
    ],
    "userCode": [
      "text-title",
      "text-userCode"
    ],
    "bodySmallCenter": [
      "text-bodySmall",
      "text-bodySmallCenter"
    ],
    "formBodyCenter": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter"
    ],
    "errorTitle": [
      "text-errorTitle"
    ],
    "detailMultiTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-detailMultiTitle"
    ],
    "rsrcImageDetailTitle": [
      "text-title",
      "text-pageTitle",
      "text-rsrcImageDetailTitle"
    ],
    "detailRsrcTitle": [
      "text-detailRsrcTitle"
    ],
    "perPage": [
      "text-perPage"
    ],
    "layerToolbar": [
      "text-layerToolbar"
    ],
    "videoControlsLoader": [
      "text-videoControlsLoader"
    ],
    "videoControlsError": [
      "text-errorTitle",
      "text-videoControlsError"
    ],
    "videoControlsPoster": [
      "text-videoControlsPoster"
    ],
    "timelineScrubberTime": [
      "text-bodySmallBold",
      "text-timelineScrubberTime"
    ],
    "timelineAxisTick": [
      "text-captionSmall",
      "text-timelineAxisTick"
    ],
    "timelineAxisSubTick": [
      "text-captionSmall",
      "text-timelineAxisTick",
      "text-timelineAxisSubTick"
    ],
    "videoControlsMessage": [
      "text-videoControlsMessage"
    ],
    "videoPlayerPill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus",
      "text-videoPlayerPill"
    ],
    "detailRsrcItemTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-detailRsrcItemTitle"
    ],
    "detailRsrcItemValue": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailRsrcItemValue"
    ],
    "rsrcTimelineError": [
      "text-errorTitle",
      "text-videoControlsError",
      "text-rsrcTimelineError"
    ],
    "rsrcTimelineMessage": [
      "text-errorTitle",
      "text-videoControlsError",
      "text-rsrcTimelineMessage"
    ],
    "error": [
      "text-error"
    ],
    "bold": [
      "text-bold"
    ],
    "tooltip": [
      "text-bodySmall",
      "text-tooltip"
    ],
    "popupSubtitle": [
      "text-subtitle",
      "text-formSubtitle",
      "text-popupSubtitle"
    ],
    "simpleSearchCaption": [
      "text-bodySmall",
      "text-simpleSearchCaption"
    ],
    "salesFlowStepTitle": [
      "text-salesFlowStepTitle"
    ],
    "salesFlowStepCaption": [
      "text-salesFlowStepCaption"
    ],
    "bodyBold": [
      "text-bodyBold"
    ],
    "salesFlowActiveStepTitle": [
      "text-salesFlowStepTitle",
      "text-salesFlowActiveStepTitle"
    ],
    "salesFlowActivetepCaption": [
      "text-salesFlowStepCaption",
      "text-salesFlowActivetepCaption"
    ],
    "theftRecoverySubtitle": [
      "text-subtitle",
      "text-cardTitle",
      "text-theftRecoverySubtitle"
    ],
    "accordionItem": [
      "text-accordionItem"
    ],
    "dialogTitleNoPad": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-dialogTitleNoPad"
    ],
    "loadingMessage": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-loadingMessage"
    ],
    "alertTitle": [
      "text-title",
      "text-alertTitle"
    ],
    "alertDetailLabel": [
      "text-bodySmall",
      "text-detailLabel",
      "text-alertDetailLabel"
    ],
    "alertDetailTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-alertDetailTitle"
    ],
    "vehicleAlert": [
      "text-locatorStatusAlert",
      "text-vehicleAlert"
    ],
    "groupingsLabel": [
      "text-groupingsLabel"
    ],
    "pairingSuggestionSubtitle": [
      "text-caption",
      "text-pairingSuggestionSubtitle"
    ],
    "link": [
      "text-link"
    ],
    "errorCaption": [
      "text-caption",
      "text-errorCaption"
    ],
    "listItemContent": [
      "text-listItemContent"
    ],
    "inactivityCaption": [
      "text-subtitle",
      "text-inactivityCaption"
    ],
    "billingDashboardTitle": [
      "text-title",
      "text-billingDashboardTitle"
    ],
    "billingCardLink": [
      "text-link",
      "text-billingCardLink"
    ],
    "billingCardBodyColor1": [
      "text-bodyBold",
      "text-billingCardBodyColor1"
    ],
    "billingCardBodyColor2": [
      "text-bodyBold",
      "text-billingCardBodyColor2"
    ],
    "billingCardBodyColor3": [
      "text-bodyBold",
      "text-billingCardBodyColor3"
    ],
    "billingCardBodyColor4": [
      "text-bodyBold",
      "text-billingCardBodyColor4"
    ],
    "billingCardFigure": [
      "text-title",
      "text-billingCardFigure"
    ],
    "sellThroughRateMet": [
      "text-sellThroughRateMet"
    ],
    "sellThroughRateFailed": [
      "text-sellThroughRateFailed"
    ],
    "descriptionSubtitle": [
      "text-subtitle",
      "text-descriptionSubtitle"
    ],
    "formFieldTitle": [
      "text-formFieldTitle"
    ],
    "infoText": [
      "text-body",
      "text-infoText"
    ],
    "gracePeriodPill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-gracePeriodPill"
    ],
    "sellThroughRateDescription": [
      "text-bold",
      "text-sellThroughRateDescription"
    ],
    "pillTheftActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillTheftActive"
    ],
    "billingCardSectionTotals": [
      "text-billingCardSectionTotals"
    ],
    "pillTheftEnding": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillTheftEnding"
    ],
    "bodySmallBoldError": [
      "text-bodySmallBold",
      "text-bodySmallBoldError"
    ],
    "salesFlowError": [
      "text-salesFlowError"
    ],
    "appStoreRecovrLogo": [
      "text-loginLogo",
      "text-appStoreRecovrLogo"
    ],
    "expiredActivationTokenLogo": [
      "text-loginLogo",
      "text-expiredActivationTokenLogo"
    ],
    "mobileOptBarCheck": [
      "text-mobileOptBarCheck"
    ],
    "columnSuffix": [
      "text-columnSuffix"
    ],
    "input": [
      "text-comparator",
      "text-input"
    ],
    "pillDTCAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillDTCAlert"
    ],
    "maintenanceEvent": [
      "text-maintenanceEvent"
    ],
    "alertTitleFull": [
      "text-title",
      "text-alertTitle",
      "text-alertTitleFull"
    ],
    "theftRecoveryInfo": [
      "text-bodySmall",
      "text-theftRecoveryInfo"
    ],
    "formNoResultsDisclaimer": [
      "text-formNoResultsDisclaimer"
    ],
    "formNoResultsInstruction": [
      "text-formNoResultsInstruction"
    ],
    "formBreakdownBody": [
      "text-formBreakdownBody"
    ],
    "copyToClipboardText": [
      "text-copyToClipboardText"
    ],
    "userEditorTitle": [
      "text-userEditorTitle"
    ],
    "apiAccessKeysTitleBar": [
      "text-apiAccessKeysTitleBar"
    ],
    "positionDetailRenderer": [
      "text-positionDetailRenderer"
    ],
    "alertText": [
      "text-body",
      "text-alertText"
    ],
    "pillMotion": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillMotion"
    ],
    "pillStationary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillStationary"
    ],
    "pillTag": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillTag"
    ],
    "pillLocator": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillLocator"
    ],
    "warning": [
      "text-warning"
    ],
    "bodyLeft": [
      "text-body",
      "text-bodyLeft"
    ],
    "boldLeft": [
      "text-bold",
      "text-boldLeft"
    ],
    "valueZone": [
      "text-valueZone"
    ],
    "valueVehicle": [
      "text-valueVehicle"
    ],
    "tableValueVehicle": [
      "text-valueVehicle",
      "text-tableValueVehicle"
    ],
    "tableValueZone": [
      "text-valueZone",
      "text-tableValueZone"
    ],
    "tablePillLocator": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillLocator",
      "text-tablePillLocator"
    ],
    "tablePillTag": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillTag",
      "text-tablePillTag"
    ],
    "tablePillTheftActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillTheftActive",
      "text-tablePillTheftActive"
    ],
    "detailPill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-detailPill"
    ],
    "detailPillMotion": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillMotion",
      "text-detailPillMotion"
    ],
    "detailPillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-detailPillSuccess"
    ],
    "detailPillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-detailPillGood"
    ],
    "detailPillLocator": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillLocator",
      "text-detailPillLocator"
    ],
    "detailPillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-detailPillWarning"
    ],
    "detailPillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-detailPillError"
    ],
    "detailValueZone": [
      "text-valueZone",
      "text-detailValueZone"
    ],
    "detailPillStationary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillStationary",
      "text-detailPillStationary"
    ],
    "detailPillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert",
      "text-detailPillAlert"
    ],
    "billDetailLabel": [
      "text-bodySmall",
      "text-detailLabel",
      "text-billDetailLabel"
    ],
    "pillTagWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillTagWarning"
    ],
    "pillJobError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillJobError"
    ],
    "pillJobActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary",
      "text-pillJobActive"
    ],
    "pillVoidWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillVoidWarning"
    ],
    "tablePillJobError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillJobError",
      "text-tablePillJobError"
    ],
    "tablePillJobActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary",
      "text-pillJobActive",
      "text-tablePillJobActive"
    ],
    "tablePillVoidWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillVoidWarning",
      "text-tablePillVoidWarning"
    ],
    "logUploadDialogTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-logUploadDialogTitle"
    ],
    "logUploadFileName": [
      "text-body",
      "text-logUploadFileName"
    ]
  },
  "props": {
    "default": {
      "iconOpts": null
    },
    "title": {
      "iconOpts": null
    },
    "subtitle": {
      "iconOpts": null
    },
    "body": {
      "iconOpts": null
    },
    "bodySmall": {
      "iconOpts": null
    },
    "caption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "captionSmall": {
      "iconOpts": null
    },
    "navLogoLabel": {
      "iconOpts": null
    },
    "pageTitle": {
      "iconOpts": null
    },
    "sectionTitle": {
      "iconOpts": null
    },
    "sectionBody": {
      "iconOpts": null
    },
    "cardTitle": {
      "iconOpts": null
    },
    "formTitle": {
      "iconOpts": null
    },
    "formSubtitle": {
      "iconOpts": null
    },
    "formBody": {
      "iconOpts": null
    },
    "listItemTitle": {
      "iconOpts": null
    },
    "listItemSubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "inputCaptionSmall": {
      "iconOpts": null
    },
    "inputCaptionSmallError": {
      "iconOpts": null
    },
    "loginWarning": {
      "iconOpts": null
    },
    "mobileMapTitle": {
      "iconOpts": null
    },
    "mobileTitle": {
      "iconOpts": null
    },
    "captionBold": {
      "iconOpts": null
    },
    "captionSmallBold": {
      "iconOpts": null
    },
    "toastTitle": {
      "iconOpts": null
    },
    "toastMsg": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "detailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "detailLabel": {
      "iconOpts": null
    },
    "detailValue": {
      "iconOpts": null
    },
    "detailSuffix": {
      "iconOpts": null
    },
    "screenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "dialogTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "sideNav": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "height": "0px",
        "width": "0px"
      },
      "useEllipsis": true
    },
    "loginLogo": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/recovr-device-management-logo.png",
      "imageOpts": {
        "height": "",
        "width": "200px"
      }
    },
    "listDetailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "mobileUserNavBar": {
      "iconOpts": null,
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "groupTitle": {
      "iconOpts": null
    },
    "dashboardCardTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "dashboardCardEditorTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "rootEditorTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "actionBar": {
      "iconOpts": null
    },
    "sideNavBarHeader": {
      "iconOpts": null
    },
    "networkOffline": {
      "iconOpts": null
    },
    "sideNavSmall": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "width": "0"
      },
      "useEllipsis": true
    },
    "linearViewHeaderCell1": {
      "iconOpts": null
    },
    "linearViewHeaderCell2": {
      "iconOpts": null
    },
    "pairingErrorSubtitle": {
      "iconOpts": null
    },
    "bodyCentered": {
      "iconOpts": null
    },
    "resendSuccess": {
      "iconOpts": null,
      "icon": "https://molten-ui-assets.storage.googleapis.com/two-step-success.png",
      "imageOpts": {
        "height": "18px",
        "width": "18px"
      }
    },
    "twoFactorWarning": {
      "iconOpts": {
        "style": {
          "color": "#E9354D",
          "fontSize": "18px"
        }
      },
      "icon": "lv lv-system-error"
    },
    "pill": {
      "iconOpts": null
    },
    "pillPrimary": {
      "iconOpts": null
    },
    "pillSuccess": {
      "iconOpts": null
    },
    "pillWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "pillError": {
      "iconOpts": null
    },
    "resendCodeSuccess": {
      "iconOpts": {
        "style": {
          "color": "#15b982",
          "fontSize": "20px"
        }
      },
      "icon": "@icon:success"
    },
    "twoStepTitle": {
      "iconOpts": null
    },
    "hint": {
      "iconOpts": null
    },
    "columnValue": {
      "iconOpts": null
    },
    "columnLabel": {
      "iconOpts": null
    },
    "conditionTitle": {
      "iconOpts": null
    },
    "missingRelTitle": {
      "iconOpts": null
    },
    "expressionParen": {
      "iconOpts": null
    },
    "operatingHoursTitle": {
      "iconOpts": null
    },
    "hintSmall": {
      "iconOpts": null
    },
    "aggregationTitle": {
      "iconOpts": null
    },
    "aggregationLabel": {
      "iconOpts": null
    },
    "aggregationValue": {
      "iconOpts": null
    },
    "overrideExample": {
      "iconOpts": null
    },
    "editorTitle": {
      "iconOpts": null
    },
    "conditionAttributeLabel": {
      "iconOpts": null
    },
    "info": {
      "iconOpts": {
        "style": {
          "color": "#0d49e4",
          "fontSize": "14px",
          "padding": "4px"
        }
      },
      "icon": "@icon:info-filled"
    },
    "conditionPropertyComparatorValue": {
      "iconOpts": null
    },
    "comparator": {
      "iconOpts": null
    },
    "tagError": {
      "iconOpts": null
    },
    "captionCurrent": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "tableConditionAttributeLabel": {
      "iconOpts": null
    },
    "mobileNavSubtitle": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "navSecondaryMobileTitle": {
      "iconOpts": null
    },
    "navSecondaryMobileHeader": {
      "iconOpts": null
    },
    "mobileScreenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      }
    },
    "mobileOptNavTitle": {
      "iconOpts": null
    },
    "mobileNavBarHeader": {
      "iconOpts": null
    },
    "ruleTrigger": {
      "iconOpts": null
    },
    "ruleBlockTitle": {
      "iconOpts": {
        "style": {
          "background": "",
          "color": "",
          "fontSize": "16px",
          "padding": ""
        }
      },
      "imageOpts": {
        "width": "24px"
      }
    },
    "ruleBlockDescription": {
      "iconOpts": null
    },
    "captionLeft": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "linkTable": {
      "iconOpts": null
    },
    "pillStatus": {
      "iconOpts": null
    },
    "pillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "value": {
      "iconOpts": null
    },
    "valueGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "valueAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-regular fa-circle-exclamation"
    },
    "valueOffline": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base500)"
        }
      },
      "icon": "fa-solid fa-wifi-slash"
    },
    "valueLowBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-battery-low"
    },
    "dashboardGridCardTitle": {
      "iconOpts": null
    },
    "passwordRequirement": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base200)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-minus"
    },
    "passwordRequirementSuccess": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-check"
    },
    "passwordRequirementError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-close"
    },
    "releaseAvailable": {
      "iconOpts": null
    },
    "openingHoursHeader": {
      "iconOpts": null
    },
    "operatingHoursDay": {
      "iconOpts": null
    },
    "groupingsCount": {
      "iconOpts": null
    },
    "groupingsCountEmpty": {
      "iconOpts": null
    },
    "formTitleCenter": {
      "iconOpts": null
    },
    "valueGoodBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-regular fa-battery-full"
    },
    "arrayValue": {
      "iconOpts": null
    },
    "ruleTargetName": {
      "iconOpts": null
    },
    "rulePathSeparator": {
      "iconOpts": null
    },
    "attributeTableUnitSuffix": {
      "iconOpts": null
    },
    "selectorColumnValue": {
      "iconOpts": null
    },
    "tablePill": {
      "iconOpts": null
    },
    "tablePillWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "tablePillSuccess": {
      "iconOpts": null
    },
    "tableArrayValue": {
      "iconOpts": null
    },
    "tablePillPrimary": {
      "iconOpts": null
    },
    "tablePillError": {
      "iconOpts": null
    },
    "tablePillStatus": {
      "iconOpts": null
    },
    "tablePillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "deviceSelectorResults": {
      "iconOpts": null
    },
    "tempUserEditorTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "32"
      }
    },
    "tempUserShareError": {
      "iconOpts": {
        "style": {
          "color": "var( --color-danger500 )",
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "aggregationEnumAggLabel": {
      "iconOpts": null
    },
    "inputCaption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "attributeDetailUnitSuffix": {
      "iconOpts": null
    },
    "attributePercentEditor": {
      "iconOpts": null
    },
    "detailArrayValue": {
      "iconOpts": null
    },
    "detailValueNoPad": {
      "iconOpts": null
    },
    "tvCollectionItemTitle": {
      "iconOpts": null
    },
    "tvDetailLabelNoPad": {
      "iconOpts": null
    },
    "tvDetailValueNoPad": {
      "iconOpts": null
    },
    "deviceCode": {
      "iconOpts": null
    },
    "iconSuccessLarge": {
      "iconOpts": null
    },
    "titleLarge": {
      "iconOpts": null
    },
    "bodyLarge": {
      "iconOpts": null
    },
    "altLoginMethod": {
      "iconOpts": null
    },
    "altLoginMethodSmall": {
      "iconOpts": null
    },
    "bodySmallBold": {
      "iconOpts": null
    },
    "qrCodeInstruction": {
      "iconOpts": null
    },
    "bodySmallBoldCenter": {
      "iconOpts": null
    },
    "userCode": {
      "iconOpts": null
    },
    "bodySmallCenter": {
      "iconOpts": null
    },
    "formBodyCenter": {
      "iconOpts": null
    },
    "errorTitle": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "detailMultiTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "rsrcImageDetailTitle": {
      "iconOpts": null
    },
    "detailRsrcTitle": {
      "iconOpts": null
    },
    "perPage": {
      "iconOpts": null
    },
    "layerToolbar": {
      "iconOpts": null
    },
    "videoControlsLoader": {
      "iconOpts": null,
      "icon": "fa-light fa-fw fa-spinner-third fa-spin"
    },
    "videoControlsError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "videoControlsPoster": {
      "iconOpts": null,
      "icon": "fa-thin fa-circle-play fa-fw"
    },
    "timelineScrubberTime": {
      "iconOpts": null
    },
    "timelineAxisTick": {
      "iconOpts": null
    },
    "timelineAxisSubTick": {
      "iconOpts": null
    },
    "videoControlsMessage": {
      "iconOpts": null
    },
    "videoPlayerPill": {
      "iconOpts": null,
      "icon": "fa-solid fa-fw fa-video"
    },
    "detailRsrcItemTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "detailRsrcItemValue": {
      "iconOpts": null
    },
    "rsrcTimelineError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "rsrcTimelineMessage": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa"
    },
    "error": {
      "iconOpts": null
    },
    "bold": {
      "iconOpts": null
    },
    "tooltip": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/light_bulb.png",
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "popupSubtitle": {
      "iconOpts": null
    },
    "simpleSearchCaption": {
      "iconOpts": null
    },
    "salesFlowStepTitle": {
      "iconOpts": null
    },
    "salesFlowStepCaption": {
      "iconOpts": null
    },
    "bodyBold": {
      "iconOpts": null
    },
    "salesFlowActiveStepTitle": {
      "iconOpts": null
    },
    "salesFlowActivetepCaption": {
      "iconOpts": null
    },
    "theftRecoverySubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "accordionItem": {
      "iconOpts": {
        "style": {
          "fontSize": "6px"
        }
      },
      "icon": "fa fa-circle"
    },
    "dialogTitleNoPad": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "loadingMessage": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "alertTitle": {
      "iconOpts": null
    },
    "alertDetailLabel": {
      "iconOpts": null
    },
    "alertDetailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "vehicleAlert": {
      "iconOpts": null
    },
    "groupingsLabel": {
      "iconOpts": null
    },
    "pairingSuggestionSubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "link": {
      "iconOpts": null
    },
    "errorCaption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "listItemContent": {
      "iconOpts": null
    },
    "inactivityCaption": {
      "iconOpts": null
    },
    "billingDashboardTitle": {
      "iconOpts": null
    },
    "billingCardLink": {
      "iconOpts": null
    },
    "billingCardBodyColor1": {
      "iconOpts": null
    },
    "billingCardBodyColor2": {
      "iconOpts": null
    },
    "billingCardBodyColor3": {
      "iconOpts": null
    },
    "billingCardBodyColor4": {
      "iconOpts": null
    },
    "billingCardFigure": {
      "iconOpts": null,
      "icon": null
    },
    "sellThroughRateMet": {
      "iconOpts": {
        "style": {
          "color": "#299e87",
          "fontSize": "18px"
        }
      },
      "icon": "fa fa-check-circle"
    },
    "sellThroughRateFailed": {
      "iconOpts": {
        "style": {
          "color": "#b8142a"
        }
      },
      "icon": "fa fa-times-circle"
    },
    "descriptionSubtitle": {
      "iconOpts": null
    },
    "formFieldTitle": {
      "iconOpts": null
    },
    "infoText": {
      "iconOpts": {
        "style": {
          "color": "#1661d7",
          "padding": "8px"
        }
      },
      "icon": "fa fa-info-circle"
    },
    "gracePeriodPill": {
      "iconOpts": null
    },
    "sellThroughRateDescription": {
      "iconOpts": null
    },
    "pillTheftActive": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/theft-recovery-pill-active-2.png",
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "billingCardSectionTotals": {
      "iconOpts": null
    },
    "pillTheftEnding": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/theft-recovery-pill-ending-2.png",
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "bodySmallBoldError": {
      "iconOpts": null
    },
    "salesFlowError": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/sales-flow-error.svg"
    },
    "appStoreRecovrLogo": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/recovr-device-management-logo.png",
      "imageOpts": {
        "height": "20px"
      }
    },
    "expiredActivationTokenLogo": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/recovr-device-management-logo.png",
      "imageOpts": {
        "height": "20px"
      }
    },
    "mobileOptBarCheck": {
      "iconOpts": {
        "style": {
          "color": "red"
        }
      }
    },
    "columnSuffix": {
      "iconOpts": null
    },
    "input": {
      "iconOpts": null
    },
    "pillDTCAlert": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "https://storage.googleapis.com/recovr-ui-assets/obd-icon.svg",
      "imageOpts": {
        "height": "20",
        "width": "20"
      }
    },
    "maintenanceEvent": {
      "iconOpts": null
    },
    "alertTitleFull": {
      "iconOpts": null
    },
    "theftRecoveryInfo": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)",
          "fontSize": "18px"
        }
      },
      "icon": "fa fa-info-circle"
    },
    "formNoResultsDisclaimer": {
      "iconOpts": null
    },
    "formNoResultsInstruction": {
      "iconOpts": null
    },
    "formBreakdownBody": {
      "iconOpts": null
    },
    "copyToClipboardText": {
      "iconOpts": null
    },
    "userEditorTitle": {
      "iconOpts": null
    },
    "apiAccessKeysTitleBar": {
      "iconOpts": null
    },
    "positionDetailRenderer": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "icon": "fak fa-lv-pin"
    },
    "alertText": {
      "iconOpts": {
        "style": {
          "color": "#1661d7",
          "padding": "8px"
        }
      },
      "icon": "https://recovr-ui-assets.storage.googleapis.com/sales-flow-error.svg"
    },
    "pillMotion": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-kit fa-lv-in-motion"
    },
    "pillStationary": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa fa-fw fa-solid fa-location-check"
    },
    "pillTag": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-recovr-tag"
    },
    "pillLocator": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-hardware-tracker"
    },
    "warning": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa fa-fw fa-solid fa-circle-exclamation"
    },
    "bodyLeft": {
      "iconOpts": null
    },
    "boldLeft": {
      "iconOpts": null
    },
    "valueZone": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-kit fa-lv-map-zone-geofence"
    },
    "valueVehicle": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-solid fa-car"
    },
    "tableValueVehicle": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-solid fa-car"
    },
    "tableValueZone": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-kit fa-lv-map-zone-geofence"
    },
    "tablePillLocator": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-hardware-tracker"
    },
    "tablePillTag": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-recovr-tag"
    },
    "tablePillTheftActive": {
      "iconOpts": null,
      "icon": "https://recovr-ui-assets.storage.googleapis.com/theft-recovery-pill-active-2.png",
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "detailPill": {
      "iconOpts": null
    },
    "detailPillMotion": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-kit fa-lv-in-motion"
    },
    "detailPillSuccess": {
      "iconOpts": null
    },
    "detailPillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "detailPillLocator": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-hardware-tracker"
    },
    "detailPillWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "detailPillError": {
      "iconOpts": null
    },
    "detailValueZone": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-kit fa-lv-map-zone-geofence"
    },
    "detailPillStationary": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa fa-fw fa-solid fa-location-check"
    },
    "detailPillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "billDetailLabel": {
      "iconOpts": null
    },
    "pillTagWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-kit fa-lv-recovr-tag"
    },
    "pillJobError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger700)"
        }
      },
      "icon": "fa-solid fa-triangle-exclamation"
    },
    "pillJobActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand700)"
        }
      },
      "icon": "fa-duotone fa-loader"
    },
    "pillVoidWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "tablePillJobError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger700)"
        }
      },
      "icon": "fa-solid fa-triangle-exclamation"
    },
    "tablePillJobActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand700)"
        }
      },
      "icon": "fa-duotone fa-loader"
    },
    "tablePillVoidWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "logUploadDialogTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "logUploadFileName": {
      "iconOpts": null
    }
  }
}